import {
  DistributionAccountRelationType,
  HomeAwaySettingsView,
  IDate,
  LeadSource,
  LocalDate,
  OnlineTravelAgency,
  UUID,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { HomeDistributionSettingsView } from '@arriere/types/Properties.types'

export interface HomesDistributionsProps {
  homeId: string
  ota: OnlineTravelAgency
}

export interface HomeCustomerExperienceIndicators {
  homeId: string
  from: IDate
  to: IDate
}

export interface DistributionListings {
  propertyType?: string
  propertyTypeGroup?: string
}

export interface DistributionSettingsView {
  commonChannelSettings: HomeDistributionSettingsView['commonChannelSettings']
  homeAwaySettings?: Partial<HomeAwaySettingsView>
  airbnbSettings?: HomeDistributionSettingsView['airbnbSettings']
}

export interface HomeListingView {
  homeId?: UUID
  source?: LeadSource
  title?: string
  externalHomeId?: string
  externalListingId?: string
  description?: string
  createdAt?: IDate
  updatedAt?: IDate
  distributionSettings?: DistributionSettingsView
  space?: string
  access?: string
  interaction?: string
  neighborhood?: string
  transit?: string
  houseRules?: string
  notes?: string
  summary?: string
  listingSummary?: {
    lockedAttributes?: string[] | null
  }
  channels?: {
    active?: boolean
    ota: OnlineTravelAgency
    title?: string
  }[]
  coHostRelation?: {
    account: {
      id: UUID
      name: string
    }
    type: DistributionAccountRelationType
  }
}

export interface ListingDescriptionFormFields {
  title?: string
  description?: string
  space?: string
  access?: string
  interaction?: string
  neighborhood?: string
  transit?: string
  notes?: string
  houseRules?: string
  headline?: string
  summary?: string
  bookingComTitle?: string
  expediaTitle?: string
  marriottTitle?: string
}

export interface UpdateHomeListingProps {
  agency: OnlineTravelAgency
  formFields: ListingDescriptionFormFields
}

export interface UpdateHomeListingMutation extends UpdateHomeListingProps {
  homeId: string
}

export interface SyncOtaDistributionProps {
  activeSection?: string
  syncOptions: OtaSyncOptions[]
}

export interface SyncDistributionParams {
  period?: {
    start: LocalDate
    end: LocalDate
  }
  pushAmenities?: boolean
  pushCalendar?: boolean
  pushContent?: boolean
  pushHomePhotos?: boolean
  pushPricing?: boolean
  pushRooms?: boolean
  pushSeasonalDiscounts?: boolean
  pushTaxFees?: boolean
}

export enum DistributionChannelsSubSection {
  guestControls = 'guest_controls',
  listingDescription = 'listing_description',
  listingInfo = 'listing_info',
  listingLockedAttributes = 'listing_locked_attributes',
  propertyDetails = 'property_details',
  tripIssues = 'trip_issues',
}

export enum DistributionNavEnum {
  airbnb = 'airbnb',
  rentalsUnited = 'rentals_united',
  vrbo = 'vrbo',
  yieldPlanet = 'yield_planet',
  listingsAndDistribution = 'listings-and-distribution',
  cancellationPolicies = 'cancellation-policies',
  paymentPlanSettings = 'payment-plan-settings',
  highlights = 'highlights',
}

export enum OtaSyncOptions {
  amenities = 'AMENITIES',
  availability = 'AVAILABILITY',
  feesAndTaxes = 'FEES_AND_TAXES',
  listingContent = 'LISTING_CONTENT',
  photos = 'PHOTOS',
  pricing = 'PRICING',
  rooms = 'ROOMS',
  seasonalDiscounts = 'SEASONAL_DISCOUNTS',
}
